import { Component } from "@angular/core";
import { SidenavItem } from "../sidenav/sidenav.component";
import { AuthService } from "../../services/auth.service";
import { OfficeService } from "@app/services/office.service";

@Component({
  selector: "app-layout",
  templateUrl: "./app-layout.component.html",
  styleUrls: ["./app-layout.component.css"],
})
export class AppLayoutComponent {
  opened = true;
  userName = "";
  companyLabel = "";

  items: SidenavItem[] = [
    { label: "Home", icon: "home", route: "/home" },
    { label: "Cargos", icon: "work", route: "/responsibilities" },
    { label: "Funcionários", icon: "groups", route: "/employees" },
    { label: "Relatórios", icon: "bar_chart", route: "/reports" },
    {
      label: "Configurações",
      icon: "settings",
      children: [{ label: "Alterar senha", route: "/change-password" }],
    },
  ];

  constructor(
    private authService: AuthService,
    private officeService: OfficeService,
  ) {
    this.userName = this.authService.getCurrentUserName();
    this.loadCompanyLabel();
  }

  onLogout(): void {
    this.authService.logout();
  }

  private loadCompanyLabel(): void {
    const currentUser = localStorage.getItem("currentUser") || sessionStorage.getItem("currentUser");
    if (!currentUser) {
      this.companyLabel = "";
      return;
    }
    try {
      const userObj = JSON.parse(currentUser);
      const selectedCompanyId = userObj.currentCompanyId;

      if (selectedCompanyId) {
        this.officeService.findById(selectedCompanyId).subscribe({
          next: (office) => {
            this.companyLabel = office.fantasyName || "";
          },
          error: (error) => {
            this.companyLabel = "";
          },
        });
        return;
      }

      this.companyLabel = "";
    } catch {
      this.companyLabel = "";
    }
  }
}
